import React, { useCallback, useEffect, useState } from 'react';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  const [hasReachedPain, setHasReachedPain] = useState(false);
  const [bounceIn, setBounceIn] = useState(false);
  useEffect(() => {
    // Show button after a short delay with bounce
    const timer = setTimeout(() => {
      setVisible(true);
      setBounceIn(true);
      // Remove bounce class after animation
      setTimeout(() => setBounceIn(false), 800);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const onScroll = () => {
      const painSection = document.getElementById('pain-section');
      if (painSection) {
        const rect = painSection.getBoundingClientRect();
        // Hide when pain section is visible in viewport
        if (rect.top <= window.innerHeight * 0.8) {
          setHasReachedPain(true);
        } else {
          setHasReachedPain(false);
        }
      }
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const handleClick = useCallback(() => {
    const painSection = document.getElementById('pain-section');
    if (painSection) {
      painSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, []);
  const shouldShow = visible && !hasReachedPain;
  return;
}